// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const KeyFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M31.463 32.361a6.045 6.045 0 0 1-8.546.003 6.045 6.045 0 0 1 0-8.548 6.04 6.04 0 0 1 8.546.003 6.04 6.04 0 0 1 0 8.542m53.164 37.467L55.859 41.06a24.36 24.36 0 0 0 1.153-7.41c0-6.48-2.525-12.572-7.107-17.154-9.461-9.46-24.853-9.462-34.311-.003-9.46 9.46-9.458 24.85.003 34.311 4.729 4.73 10.94 7.094 17.154 7.094 3.333 0 6.658-.703 9.762-2.064l7.659 7.66c.397.395.943.603 1.5.583l4.88-.206 1.639 10.57a2 2 0 0 0 1.952 1.693l7.713.094a9.763 9.763 0 0 0 2.873 7.5 9.792 9.792 0 0 0 6.948 2.874 9.8 9.8 0 0 0 6.95-2.874c3.83-3.832 3.83-10.067 0-13.899"
			fillRule="evenodd"
		/>
	</svg>
);
export default KeyFilled;
